{
  "name": "@m3s/wallet",
  "version": "2.2.2",
  "type": "module",
  "description": "A flexible wallet interface supporting multiple blockchain wallet types, including EVM wallets and Web3Auth integration",
  "license": "MIT",
  "keywords": [
    "wallet",
    "ethereum",
    "web3auth",
    "blockchain",
    "evm",
    "oauth",
    "crypto",
    "web3"
  ],
  "repository": {
    "type": "git",
    "url": "git@bitbucket.org:ctb-marisca/ms3-package.git",
    "directory": "packages/wallet"
  },
  "main": "./dist/index.cjs.js",
  "module": "./dist/index.esm.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.esm.js",
      "require": "./dist/index.cjs.js"
    }
  },
  "scripts": {
    "build": "tsc -b",
    "prepublishOnly": "npm run build",
    "test": "vitest run --sequence.sequential"
  },
  "dependencies": {
    "ethers": "^6.13.5",
    "joi": "^17.13.3"
  },
  "devDependencies": {
    "@m3s/shared": "*"
  },
  "peerDependencies": {
    "@web3auth/auth-adapter": "9.7.0",
    "@web3auth/base": "9.7.0",
    "@web3auth/ethereum-provider": "9.7.0",
    "@web3auth/no-modal": "9.7.0"
  },
  "peerDependenciesMeta": {
    "@web3auth/auth-adapter": {
      "optional": true
    },
    "@web3auth/base": {
      "optional": true
    },
    "@web3auth/ethereum-provider": {
      "optional": true
    },
    "@web3auth/no-modal": {
      "optional": true
    }
  },
  "publishConfig": {
    "access": "public",
    "tag": "latest"
  },
  "files": [
    "dist"
  ],
  "engines": {
    "node": ">=18.0.0"
  }
}
